export const navLinks = {
  ROOT: '/times',
  BY_ID: '/times/byid',
  SEARCH: '/times/search',
  SEARCH_WITH_ENGINE: '/times/searchwithsearchengine',
  DETAIL: '/times/info',
  SPLITS: '/times/splits',
  RECOGNITION: '/times/recognition',
  RELAY_LEGS: '/times/relaylegs'
};